import React from 'react';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import styles from './TenantUnavailable.module.css';

// Tela de erro amigável para quando a empresa (tenant) do chat não pôde
// ser identificada -- Task 8b (tenancy-foundation). Substitui o chat
// inteiro (nada de formulário de login, nada de tela em branco) sempre
// que a API responder 400/404 de resolução de tenant: slug inválido,
// desconhecido, ou de uma empresa suspensa (status != active). Ver
// assets/api/http-client.js, que detecta essa falha e guarda a mensagem
// no redux (redux/tenant).
const TenantUnavailable = ({ message }) => (
  <div className={styles.tenantUnavailable}>
    <BusinessOutlinedIcon className={styles.icon} />
    <h3>Atendimento indisponível</h3>
    <p className={styles.message}>
      {message || 'Não foi possível identificar a empresa deste atendimento.'}
    </p>
  </div>
);

export default TenantUnavailable;
